export const MEDICATIONREPORTLIST_SEARCH = 'MEDICATIONREPORTLIST_SEARCH';
export const MEDICATIONREPORTLIST_PAGE = 'MEDICATIONREPORTLIST_PAGE';
export const MEDICATIONREPORTLIST_STARTDATE = 'MEDICATIONREPORTLIST_STARTDATE';
export const MEDICATIONREPORTLIST_ENDDATE = 'MEDICATIONREPORTLIST_ENDDATE';
export const MEDICATIONREPORTLIST_ACTIVITYLABELID = 'MEDICATIONREPORTLIST_ACTIVITYLABELID';
export const MEDICATIONREPORTLIST_ADMINISTRATORSTATUS = 'MEDICATIONREPORTLIST_ADMINISTRATORSTATUS';
